import { render } from "./Tem007.vue?vue&type=template&id=b75d4a6a&scoped=true"
import script from "./Tem007.vue?vue&type=script&lang=js"
export * from "./Tem007.vue?vue&type=script&lang=js"

import "./Tem007.vue?vue&type=style&index=0&id=b75d4a6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75d4a6a"]])

export default __exports__